import classNames from 'helpers/class-names'
import { FC, HTMLAttributes, ReactNode, useMemo } from 'react'

type StackProps = {
  children: ReactNode
  className?: string
  vertical?: boolean
  spacing?: number
  vAlign?: 'start' | 'center' | 'end' | 'between' | 'around'
  hAlign?: 'start' | 'center' | 'end' | 'between' | 'around'
} & HTMLAttributes<HTMLDivElement>

export const Stack: FC<StackProps> = ({
  className,
  vertical = false,
  spacing = 0,
  children,
  vAlign,
  hAlign,
  ...rest
}) => {
  const spacingClass = vertical ? `space-y-${spacing}` : `space-x-${spacing}`
  const hAlignClass = useMemo(() => {
    if (vertical) {
      switch (hAlign) {
        case 'start':
          return 'items-start'
        case 'center':
          return 'items-center'
        case 'end':
          return 'items-end'
        case 'between':
          return 'justify-between'
        case 'around':
          return 'justify-around'
        default:
          return ''
      }
    }
    switch (hAlign) {
      case 'start':
        return 'justify-start'
      case 'center':
        return 'justify-center'
      case 'end':
        return 'justify-end'
      case 'between':
        return 'justify-between'
      case 'around':
        return 'justify-around'
      default:
        return ''
    }
  }, [hAlign, vertical])

  const vAlignClass = useMemo(() => {
    if (vertical) {
      switch (vAlign) {
        case 'start':
          return 'justify-start'
        case 'center':
          return 'justify-center'
        case 'end':
          return 'justify-end'
        case 'between':
          return 'justify-between'
        case 'around':
          return 'justify-around'
        default:
          return ''
      }
    }
    switch (vAlign) {
      case 'start':
        return 'items-start'
      case 'center':
        return 'items-center'
      case 'end':
        return 'items-end'
      case 'between':
        return 'justify-between'
      case 'around':
        return 'justify-around'
      default:
        return ''
    }
  }, [vAlign, vertical])

  return (
    <div
      className={classNames(
        'flex',
        spacingClass,
        hAlignClass,
        vAlignClass,

        {
          'flex-col': vertical,
        },
        className,
      )}
      {...rest}>
      {children}
    </div>
  )
}
